export default __webpack_public_path__ + "static/media/mural.db6eed2b.jpg";